import React, { useEffect, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  fileToBase64,
  handleError,
  handleSuccess,
  setMockFile,
} from "../../../utils";
import http from "../../../core/service/http";
import { setAuth } from "../../../core/store/app-store/app-store";

export const useMyProfileHook = () => {
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state?.appStore?.auth);
  const user = auth.user[0];
  const [initialValues, setInitialValues] = useState({
    member_id: user.member_id,
    firstName: user.first_name,
    lastName: user.last_name,
    phone: user.contact_no_1,
    address: user.address_1,
    country: user.country,
    city: user.city,
    zip: user.zip_code,
    billOption: "Driving License",
    bill: user.bill || "",
    driving_license: user.driving_license || "",
    billBase64: user.billBase64 || "",
    licenseBase64: user.licenseBase64 || "",
    profile_picture: user.profile_picture || "",
  });
  const validationSchema = Yup.object({
    member_id: Yup.string().required("Member ID is required."),
    firstName: Yup.string().required("First name is required."),
    lastName: Yup.string().required("Last name is required."),
    phone: Yup.string()
      .required("Phone number is required."),
    address: Yup.string().required("Address is required."),
    country: Yup.string().required("Country is required."),
    city: Yup.string().required("City is required."),
    zip: Yup.string()
      .matches(/^\d{5}$/, "Zip code must be 5 digits.")
      .required("Zip code is required."),
    billOption: Yup.string().required("Choose one option"),
    bill: Yup.string().required("Bill is required"),
    driving_license: Yup.string().required("Driving License is required"),
    profile_picture: Yup.string(),
  });

  const getData = async () => {
    const response = await http.get("/v1/users/0");
    const data = JSON.parse(localStorage.getItem("data"));
    data.user[0] = response.data;
    const updatedData = {
      ...auth,
      user: [
        {
          ...response.data,
        },
      ],
      uploads: response.data.uploads,
    };
    localStorage.setItem("data", JSON.stringify(updatedData));
    dispatch(setAuth(updatedData));
    await setInitialValues({
      member_id: response.data.member_id,
      firstName: response.data.first_name,
      lastName: response.data.last_name,
      phone: response.data.contact_no_1,
      address: response.data.address_1,
      country: response.data.country,
      city: response.data.city,
      zip: response.data.zip_code,
      billOption: response.data.uploads.find(
        (i) => i.title == "Driving License" || i.title == "Passport"
      )?.title,
    });
    setTimeout(() => {
      setMockFile("Utility Bill", "driving_license");
      setMockFile(
        response.data.uploads.find(
          (i) => i.title == "Driving License" || i.title == "Passport"
        )?.title,
        "bill"
      );
    });
  };
  useEffect(() => {
    getData();
  }, []);
  const onFileChangeHandler = async (event, setFieldValue, fieldName) => {
    const file = event.target.files[0];
    const base64 = await fileToBase64(file);
    setFieldValue(fieldName, base64);
  };

  return {
    isLoading,
    setLoading,
    initialValues,
    validationSchema,
    onFileChangeHandler,
    getData
  };
};
